import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Features from "../components/Features";
import WorkProcess from "../components/WorkProcess";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import AboutMe from "../components/AboutMe";

const Home = () => {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <AboutMe />
        <WorkProcess />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
